import {
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel, Box,
} from '@chakra-ui/react';
import React from 'react';

const RSAccordionAction = ({ children, label}) => {
  return (
    <Accordion allowToggle  defaultIndex={[0]} className='accordion' border='none'>
      <AccordionItem className='item'>
        <h2 >
          <AccordionButton className='accordionButton sidebarButton'>
            <Heading className='heading sectionTitle sidebarSectionTitle'>{label}</Heading>
            <AccordionIcon className='icon sidebarIcon' />
          </AccordionButton>
        </h2>
        <AccordionPanel className='panel'>
          <Box className="panelInterior">
            <Box className="panelPadding">{children}</Box>
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>

  );
};
export default RSAccordionAction;